var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-anchor",attrs:{"id":_vm.name}},[_vm._t("default"),_vm._v(" "),(_vm.$slots.default == 'undefined')?_c('p',{staticClass:"sr-only"},[_vm._v("Section: "+_vm._s(_vm.name))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }